import { inject } from '@angular/core';
import { HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

// Endpointy auth, które NIE powinny triggerować refresh (żeby uniknąć pętli)
const NO_REFRESH_URLS = ['/auth/refresh', '/auth/logout'];

function isNoRefreshUrl(url: string): boolean {
  // Sprawdź listę prefiksów ORAZ dokładne dopasowanie /auth (endpoint logowania)
  return NO_REFRESH_URLS.some(path => url.includes(path))
    || /\/auth$/.test(url.replace(/\?.*$/, ''));
}

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const auth = inject(AuthService);

  const authReq = addToken(req, auth.getAccessToken());

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !isNoRefreshUrl(req.url)) {
        return handle401(req, next, auth);
      }
      return throwError(() => error);
    })
  );
}

function addToken(req: HttpRequest<unknown>, token: string | null): HttpRequest<unknown> {
  if (!token) return req;
  return req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
}

function handle401(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
  auth: AuthService
): Observable<HttpEvent<unknown>> {
  if (auth.isCurrentlyRefreshing) {
    return auth.waitForToken().pipe(
      switchMap(token => next(addToken(req, token)))
    );
  }

  return auth.startRefresh().pipe(
    switchMap(tokens => next(addToken(req, tokens.accessToken))),
    catchError(err => throwError(() => err))
  );
}
